<div class="card-container">
  <div class="card-header">
    {{ header }}
  </div>
  <div class="card-text bold">
    <ng-content></ng-content>
  </div>
</div>
